import { HashRouter, Route, Routes } from "react-router-dom"
import LogInPage from "../pages/LogInPage/LogInPage"
import LogInTokenPage from "../pages/LogInTokenPage/LogInTokenPage"
import LogInWithPinPage from "../pages/LogInWithPinPage/LogInWithPinPage"
import SignUpPage from "../pages/SignUpPage/SignUpPage"
import ProfilePage from "../pages/ProfilePage/ProfilePage"
import RateTMHPage from "../pages/RateTMHPage/RateTMHPage"
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage"
import InstallDirectPage from "../pages/InstallDirectPage/InstallDirectPage"
import InstallDirectPageMobile from "../pages/InstallDirectPageMobile/InstallDirectPageMobile"
import VisitRokuWebsitePage from "../pages/VisitRokuWebsite/VisitRokuWebsitePage"
import CongratulationPage from "../pages/CongratulationPage/CongratulationPage"
import CongratulationsPage from "../pages/CongratulationsPage/CongratulationsPage"
import PrivacyPoliciesPage from "../pages/PrivacyPolicyPage/PrivacyPolicyPage"
import DMCAPage from "../pages/DMCAPage/DMCAPage"
import ContactUsPage from "../pages/ContactUsPage/ContactUsPage"
import ForgotPasswordPage from "../pages/ForgotPasswordPage/ForgotPasswordPage"
import ResetPasswordPage from "../pages/ResetPasswordPage/ResetPasswordPage"
import VerificationPage from "../pages/VerificationPage/VerificationPage"
import AboutPage from "../pages/AboutPage/AboutPage"
import TermsConditionPage from "../pages/TermsConditionPage/TermsConditionPage"
import RequestCouponPage from "../pages/RequestCouponPage/RequestCouponPage"
import VuduInstructionPage from "../pages/VuduInstructionPage/VuduInstructionPage"
import AmazonInstructionPage from "../pages/AmazonInstructionPage/AmazonInstructionPage"
import ConfirmEmailSuccessPage from "../pages/ConfirmEmailSuccessPage/ConfirmEmailSuccessPage"
import FAQPage from "../pages/FAQPage/FAQPage"

export default function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<SignUpPage />} />
        <Route path="signup" element={<SignUpPage />} />
        <Route path="congratulations" element={<CongratulationPage />} />
        <Route path="fmq-congratulations" element={<CongratulationsPage />} />
        <Route path="login" element={<LogInPage />} />
        <Route path="login/:message" element={<LogInPage />} />
        <Route path="login-with-token/:token" element={<LogInTokenPage />} />
        <Route path="login-with-token/:token/:cid" element={<LogInTokenPage />} />
        <Route path="loginwithpin/:pin" element={<LogInWithPinPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password/:email/:ts/:hash" element={<ResetPasswordPage />} />
        <Route path="install-direct" element={<InstallDirectPage />} />
        <Route path="install-direct/:mobile" element={<InstallDirectPage />} />
        <Route path="install-direct-mobile" element={<InstallDirectPageMobile />} />
        <Route path="visit-roku-website" element={<VisitRokuWebsitePage />} />
        <Route path="verification" element={<VerificationPage />} />
        <Route path="verification/:id" element={<VerificationPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/:message" element={<ProfilePage />} />
        <Route path="rate-movie-house" element={<RateTMHPage />} />
        <Route path="request-coupon" element={<RequestCouponPage />} />
        <Route path="request-coupon/:pin/:email_hash" element={<RequestCouponPage />} />
        <Route path="privacy-policy" element={<PrivacyPoliciesPage />} />
        <Route path="terms-conditions" element={<TermsConditionPage />} />
        <Route path="dmca" element={<DMCAPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact-us" element={<ContactUsPage />} />
        <Route path="how-to-redeem-vudu-rewards" element={<VuduInstructionPage />} />
        <Route path="how-to-redeem-amazon-rewards" element={<AmazonInstructionPage />} />
        <Route path="confirm-email-success/:email/:hash" element={<ConfirmEmailSuccessPage />} />
        <Route path="404" element={<NotFoundPage />} />
        <Route path="*" element={<SignUpPage />} />
      </Routes>
    </HashRouter>
  )
}
